/* global google */
export default class AddressMap {
    constructor(config, locations, baseLocation) {
        this.config = config;
        this.locations = locations;
        this.markers = {};
        this.infoWindows = {};
        this.baseLocation = baseLocation;
        if (!this.config.zoom) {
            this.config.zoom = 13;
        }
        this.idTranslation = {};
    }

    render() {
        const canvasNode = document.getElementById(this.config.canvasId);
        if (!canvasNode) {
            throw new Error('Cannot find map canvas with id: ' + this.config.canvasId);
        }

        this.map = new google.maps.Map(canvasNode, {
            zoom: this.config.zoom,
            // default location of Hamburg City
            center: new google.maps.LatLng(53.5440432, 9.9940413),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        });

        this.bundledLocations = {};

        if (this.baseLocation) {
            this.map.setCenter({
                lat: this.baseLocation.lat,
                lng: this.baseLocation.lng,
            });

            this.setMarkerByGeolocation(
                this.baseLocation.lat,
                this.baseLocation.lng,
                this.baseLocation.pinId,
                this.baseLocation.text,
                true
            );
        }

        for (const pinId in this.locations) {
            const location = this.locations[pinId];
            if (!this.bundledLocations[location.address]) {
                this.idTranslation[pinId] = pinId;
                this.bundledLocations[location.address] = {
                    pinId,
                    lat: location.lat,
                    lng: location.lng,
                    info: location.text,
                };
            } else {
                this.idTranslation[pinId] =
                    this.bundledLocations[location.address].pinId;

                this.bundledLocations[location.address].info +=
                    '<br />-------------------------<br />' + location.text;
            }
        }

        for (const address in this.bundledLocations) {
            const loc = this.bundledLocations[address];

            this.setMarkerByGeolocation(
                loc.lat,
                loc.lng,
                loc.pinId,
                loc.info,
                false
            );
        }

        this.map.setZoom(this.config.zoom);
    }

    showMarkerInfo(id) {
        this.hideMarkerInfos();
        const pinId = this.idTranslation[id];
        const marker = this.markers[pinId];
        const infoWindow = this.infoWindows[pinId];

        if (marker && infoWindow) {
            infoWindow.open({
                map: this.map,
                anchor: marker,
            });
        }
    }

    setMarkerByGeolocation(lat, lng, id, info, isBaseLocation) {
        let marker;
        if(isBaseLocation) {
            const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"><polygon points="32,12 2,36 12,36 12,60 52,60 52,36 62,36" fill="#ffb400" stroke="#333" stroke-width="2"/><rect x="24" y="36" width="16" height="24" fill="#FFF" stroke="#333" stroke-width="2"/></svg>';
            marker = new google.maps.Marker({
                map: this.map,
                position: { lat, lng },
                icon: {
                    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgIcon),
                    scaledSize: new google.maps.Size(32, 32),
                },
            });
        } else {
            marker = new google.maps.Marker({
                map: this.map,
                position: { lat, lng },
            });
        }

        const infoWindow = new google.maps.InfoWindow({
            content: info,
        });

        marker.addListener('click', () => {
            this.hideMarkerInfos();
            infoWindow.open({
                map: this.map,
                anchor: marker,
            });
        });
        this.markers[id] = marker;
        this.infoWindows[id] = infoWindow;

    }

    hideMarkerInfos() {
        Object.values(this.infoWindows).forEach(infoWindow => infoWindow.close());
    }

    destroy() {
        this.hideMarkerInfos();

        Object.values(this.markers).forEach(marker => {
            marker.map = null;
        });

        this.markers = {};
        this.infoWindows = {};

        if (this.map) {
            delete this.map;
        }

        const canvasNode = document.getElementById(this.config.canvasId);
        if (canvasNode) {
            canvasNode.innerHTML = '';
        }
    }
}
